import React from 'react';
import {
  Card, Row, Col,
} from 'react-bootstrap';
import '../alert-form.css';
import { useDispatch, useSelector } from 'react-redux';
import Icon
  from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';

import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import AltErrorWrapper
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import AlertFormAdditionalSensors from './AlertFormAdditionalSensors';
import NameAlertInput from './NameAlertInput';
import TagsMultiSelect
  from '../../../alerts/AlertDetailsPage/EditAlertConditionFormWrapper/TagsMultiselect/TagsMultiSelect';
import {
  AlertFormSteps,
  selectNameAlertData,
  selectSensorsData,
  updateStepData,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import TimezoneSelect from './TimezoneSelect';

function NameAlertAndMoreForm() {
  const dispatch = useDispatch();
  const nameAlertStepData = useSelector(selectNameAlertData);
  const { selectedChannels } = useSelector(selectSensorsData);
  const alertNameLabelText = selectedChannels && selectedChannels.length === 1
    ? 'Alert Name' : 'Alert Naming Convention';

  return (
    <FormErrorHandler
      fieldList={['alertNameInput', 'alertTags', 'timeZoneName', 'additionalSensors']}
      errorList={nameAlertStepData.errorList}
    >
      <Card className="alert-card">
        <Card.Body>
          <h6 className="mb-4 alert-form-section-label">Finally, name your alerts, add tags, and more</h6>
          <Row className="mb-3 align-items-center">
            <Col sm={12} md={2} className="text-md-right alert-form-input-label">
              {alertNameLabelText}
            </Col>
            <Col sm={12} md={10} lg={9}>
              <AltErrorWrapper fieldId="alertNameInput">
                <NameAlertInput />
              </AltErrorWrapper>
            </Col>
          </Row>
          {nameAlertStepData.duplicateNamesDetected && (
          <Row className="mb-3 align-items-center">
            <Col sm={12} md={2} className="text-md-right alert-form-input-label" />
            <Col sm={12} md={10} lg={9}>
              <Icon icon="triangle-exclamation" className="text-warning mr-1" />
              <small className="text-warning center">
                Some alerts will end up with the same name. Try adding keywords
                to the name template.
              </small>

            </Col>
          </Row>
          )}

          <Row className="mb-3 align-items-center">
            <Col sm={12} md={2} className="text-md-right alert-form-input-label">
              Tags
            </Col>
            <Col sm={12} md={10} lg={9}>
              <AltErrorWrapper fieldId="alertTags">
                <TagsMultiSelect
                  selectedTags={nameAlertStepData.alertTags}
                  setSelectedTags={(tagIds) => {
                    dispatch(updateStepData({
                      step: AlertFormSteps.NAME_ALERT,
                      data: { alertTags: tagIds },
                    }));
                  }}
                />
              </AltErrorWrapper>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center">
            <Col sm={12} md={2} className="text-md-right alert-form-input-label">
              Timezone
            </Col>
            <Col sm={12} md={10} lg={9}>
              <AltErrorWrapper fieldId="timeZoneName">
                <TimezoneSelect
                  className="form-control w-auto"
                  value={nameAlertStepData.timeZoneName}
                  onChange={(timeZoneName) => {
                    dispatch(updateStepData({
                      step: AlertFormSteps.NAME_ALERT,
                      data: { timeZoneName },
                    }));
                  }}
                />
              </AltErrorWrapper>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col sm={12} md={2} className="text-md-right alert-form-input-label">
              Additional Sensors
            </Col>
            <Col sm={12} md={10} lg={9}>
              <AltErrorWrapper fieldId="additionalSensors">
                <AlertFormAdditionalSensors />
              </AltErrorWrapper>
            </Col>
          </Row>

        </Card.Body>
      </Card>
    </FormErrorHandler>
  );
}

export default NameAlertAndMoreForm;
